<template>
  <div class="d-flex justify-end">
    <v-btn class="search-button" outlined color="success" @click="exportExcel">
      <v-icon left>mdi-file-excel</v-icon> Xuất Excel
    </v-btn>
  </div>
</template>
<script>
import { headerExcel } from './helper'
import utils from '@/plugins/utils'
import { TuitionFeeDebt } from '@/plugins/api'
import { mapGetters } from 'vuex'
import { get } from 'lodash'
export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      query: 'studentDebt/getQuery',
    }),
  },
  methods: {
    async exportExcel() {
      this.$loading.active = true
      try {
        let filter = this.$options.filters
        const res = await TuitionFeeDebt.fetch({ ...this.query, _limit: -1 })
        const data = []
        res.forEach(item => {
          item.name = get(item.student, 'name', '')
          item.code = filter.getStudentCode(item.student.code)
          item.dob = filter.ddmmyyyy(item.student.dob)
          item.class = get(item.class, 'title', '')
          item.totalAmount = get(item, 'totalAmount', 0)
          data.push(item)
        })
        utils.exportExcel(data, headerExcel, `Danh sách công nợ`)
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    },
  },
}
</script>
